<div class="container-fluid pb-5">

  <div class="row pt-5 d-print-none">
    <div class="col-md-2"></div>
    <div class="col-md-8">
      <img src="./assets/images/logo.png" style="width: 100%;">
    </div>
    <div class="col-md-2"></div>
  </div>

  <div class="row mt-5">
    <div class="col-md-2"></div>
    <div class="col-md-8">
      <p>L’Ajuntament de Sant Just Desvern va implantar des del curs escolar 2020-2021 un nou
        sistema de preus públics de l’Escola Bressol Municipal Marrecs basat en la tarifació social.
        Aquesta tarifació permet ajustar les quotes de manera individual i diferenciada a la renda i
        extensió de la unitat familiar a la que pertanyin els infants que rebin la seva educació
        infantil a Marrecs.</p>

      <b>Simulador dels preus públics per a l’escolarització d’infants a l’EBM Marrecs.</b>
      <p>L’objectiu d’aquesta calculadora és orientar les famílies amb infants de 0-3 anys que
        desitgin inscriure’ls a l’EBM Marrecs perquè puguin conèixer quins serien, en el seu cas
        particular, els preus públics aplicables en cadascun dels serveis que podrien rebre.
        Els imports resultants es calculen en funció de les variables, de renda i nombre de
        membres de la unitat familiar, que utilitza el simulador, d’acord amb l’ordenança municipal
        aprovada per l’Ajuntament de Sant Just Desvern.</p>

      <p style="color: red;">El resultats obtinguts amb la calculadora, per part de les persones particulars, és fruit de les dades
        introduïdes i no genera cap dret adquirit per a aquestes, ni vincula a l’Administració fins el moment en que a
        través del corresponent procediment administratiu i la verificació de totes les dades aplicables es calculi la
        liquidació definitiva de la quota.</p>

      <p>A la quantitat obtinguda se li aplicarà un coeficient social reductor quan es compleixi en el nucli familiar
        alguna de les següents condicions durant el mateix curs escolar pel qual es matricula. (màxim 20%)</p>

      <p style="color: red;">
        NOTA: L’IMPORT RESULTANT DE LA QUOTA PER ALS INFANTS DE P2 ÉS ORIENTATIU JA QUE EN EL PROPER CURS ESTÀ PREVIST QUE EL SERVEI EDUCATIU DE LES BRESSOL MUNICIPALS SIGUI GRATUÏT I EL DE LES PRIVADES PODRIA REBRE UNA SUBVENCIÓ
      </p>

    </div>
    <div class="col-md-2"></div>
  </div>

  <div class="row">
    <div class="col-md-2"></div>
    <div class="col-md-8">
      <br/>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="germans" name="germans" [(ngModel)]="germans">
        <label class="form-check-label">
          L’infant tindrà altres germans i/o germanes matriculats/des a Marrecs. (20%)
        </label>
      </div>
      <br/>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="discapacitat" name="discapacitat"
               [(ngModel)]="discapacitat">
        <label class="form-check-label">
          Algun membre de la unitat familiar de l'infant tindrà reconeguda la discapacitat o invalidesa. (10%)
        </label>
      </div>
      <br/>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="regim_acolliment" name="regim_acolliment"
               [(ngModel)]="regim_acolliment">
        <label class="form-check-label">
          La unitat familiar de l'infant tindrà un altre infant en règim d'acolliment. (10%)
        </label>
      </div>
      <div class="col-md-2"></div>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-md-3"></div>
    <div class="col-md-3">
      <label class="mr-2" data-toggle="modal"
             data-target="#exampleModalCenter1">Renda unitat familar:</label>
      <img src="./assets/images/help.png" style="width: 20px; height: 20px; cursor:pointer;" data-toggle="modal"
           data-target="#exampleModalCenter1">
      <div class="input-group">
        <input type="text" class="form-control" [(ngModel)]="C2" aria-label="Renda mensual unitat familiar">
        <div class="input-group-append">
          <span class="input-group-text">€</span>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <label class="mr-2" data-toggle="modal"
             data-target="#exampleModalCenter2">Membres de la unitat familiar:</label>
      <img src="./assets/images/help.png" style="width: 20px; height: 20px; cursor:pointer;" data-toggle="modal"
           data-target="#exampleModalCenter2">
      <input class="form-control" type="text" [(ngModel)]="C3">
    </div>
    <div class="col-md-3"></div>
  </div>


  <div class="row pt-5" *ngIf="show_table()">
    <div class="col-md-3"></div>
    <div class="col-md-6">
      <table class="table">
        <thead class="thead-dark">
        <tr>
          <th scope="col">Servei</th>
          <th scope="col">Quota bàsica</th>
          <th scope="col">Quota personal</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <th scope="row" class="table-secondary">Escolarització</th>
          <td class="table-secondary">{{ B12 }} €</td>
          <td class="table-secondary">{{ D12() }} €</td>
        </tr>
        <tr>
          <th scope="row" colspan="3" class="table-secondary">Servei de menjador</th>
        </tr>
        <tr>
          <th scope="row">Menjador complert</th>
          <td>{{ B15 }} €</td>
          <td>{{ D15() }} €</td>
        </tr>
        <tr>
          <th scope="row">Menjador lactants</th>
          <td>{{ B16 }} €</td>
          <td>{{ D16() }} €</td>
        </tr>
        <tr>
          <th scope="row">Berenar</th>
          <td>{{ B17 }} €</td>
          <td>{{ D17() }} €</td>
        </tr>
        <tr>
          <th scope="row" colspan="3" class="table-secondary">Servei d'acollida (de 8 a 8.30 h o de 17 a 17.30 h)</th>
        </tr>
        <tr>
          <th scope="row">De setembre a juny</th>
          <td>{{ B20 }} €</td>
          <td>{{ D20() }} €</td>
        </tr>
        <tr>
          <th scope="row">Juliol</th>
          <td>{{ B21 }} €</td>
          <td>{{ D21() }} €</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-3"></div>
  </div>

  <div class="row d-flex justify-content-center" *ngIf="show_table()">
    <p>
      <a class="btn btn-primary mr-2" data-toggle="collapse" href="#multiCollapseExample1" role="button"
         aria-expanded="false"
         aria-controls="multiCollapseExample1">Altres serveis</a>
      <a class="btn btn-primary ml-3 d-print-none" href="#" role="button"
         (click)="print()"
         aria-expanded="false"
         aria-controls="multiCollapseExample1">Imprimir</a>
    </p>
  </div>
  <div class="row" *ngIf="show_table()">
    <div class="col-md-3"></div>
    <div class="col-md-6">
      <div class="collapse multi-collapse" id="multiCollapseExample1">
        <div class="row">
          <table class="table">
            <thead class="thead-dark">
            <tr>
              <th scope="col">Servei</th>
              <th scope="col">Quota bàsica</th>
              <th scope="col">Quota personal</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th scope="row" colspan="3" class="table-secondary">Servei de menjador fix parcial</th>
            </tr>
            <tr>
              <th scope="row" colspan="3" class="table-secondary" style="background-color: #d6d8db66;">3 vegades/setmana</th>
            </tr>
            <tr>
              <th scope="row">Menjador complert</th>
              <td>{{ B28 }} €</td>
              <td>{{ D28() }} €</td>
            </tr>
            <tr>
              <th scope="row">Menjador lactants</th>
              <td>{{ B29 }} €</td>
              <td>{{ D29() }} €</td>
            </tr>
            <tr>
              <th scope="row" colspan="3" class="table-secondary" style="background-color: #d6d8db66;">2 vegades/setmana</th>
            </tr>
            <tr>
              <th scope="row">Menjador complert</th>
              <td>{{ B31 }} €</td>
              <td>{{ D31() }} €</td>
            </tr>
            <tr>
              <th scope="row">Menjador lactants</th>
              <td>{{ B32 }} €</td>
              <td>{{ D32() }} €</td>
            </tr>
            <tr>
              <th scope="row" colspan="3" class="table-secondary" style="background-color: #d6d8db66;">1 vegades/setmana</th>
            </tr>
            <tr>
              <th scope="row">Menjador complert</th>
              <td>{{ B34 }} €</td>
              <td>{{ D34() }} €</td>
            </tr>
            <tr>
              <th scope="row">Menjador lactants</th>
              <td>{{ B35 }} €</td>
              <td>{{ D35() }} €</td>
            </tr>
            <tr>
              <th scope="row" colspan="3" class="table-secondary">Serveis esporàdics</th>
            </tr>
            <tr>
              <th scope="row">Menjador complert</th>
              <td>{{ B38 }} €</td>
              <td>{{ D38() }} €</td>
            </tr>
            <tr>
              <th scope="row">Menjador lactants</th>
              <td>{{ B39 }} €</td>
              <td>{{ D39() }} €</td>
            </tr>
            <tr>
              <th scope="row">Berenar</th>
              <td>{{ B40 }} €</td>
              <td>{{ D40() }} €</td>
            </tr>
            <tr>
              <th scope="row">Esporàdic 30 minuts</th>
              <td>{{ B41 }} €</td>
              <td>{{ D41() }} €</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-md-3"></div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog"
       aria-labelledby="exampleModalCenterTitle1"
       aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle1">Renda bruta anual de la unitat familiar</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Dades de la Renda 2021</p>
          Els ingressos familiars s’obtindran per la suma de les caselles 435 (base imposable general) i 460 (base
          imposable de l'estalvi) de la declaració de la renda corresponent a l'exercici 2021 de cadascun dels membres
          del nucli familiar.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Tancar</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="exampleModalCenter2" tabindex="-1" role="dialog"
       aria-labelledby="exampleModalCenterTitle2"
       aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle2">Membres de la unitat familiar</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Inclou persones progenitores, germans/es, infants i persones majors d’edat amb discapacitat</p>
          Es consideren membres de la unitat familiar, a més de l'infant, els pares, mares, tutors/es o persones
          encarregades de la guarda i custòdia i germans/es solters/es menors de 25 anys que convisquin al mateix
          domicili en el moment de formalitzar la matrícula, i majors d'edat quan es tracti de persones amb
          discapacitat.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal">Tancar</button>
        </div>
      </div>
    </div>
  </div>

</div>
<!--  <hr>-->
<!--  <hr>-->
<!--  <hr>-->

<!--  <br/>Renda mensual equivalent = {{ C5().toFixed(2) }} €-->
<!--  <br/>quota personal escolarizacio = {{ D12() }} €-->
<!--  <br/>quota personal menjador complert = {{ D15() }} €-->
<!--  <br/>quota personal menjador lactants = {{ D16() }} €-->
<!--  <br/>quota berenar = {{ D17() }} €-->

<!--  <br/>servei acollida set a juny personal = {{ D20() }} €-->
<!--  <br/>servei acollida juliol personal = {{ D21() }} €-->

<!--  <br/>menjador 3 cops setmana complert = {{ D28() }} €-->
<!--  <br/>menjador 3 cops setmana lactants = {{ D29() }} €-->

<!--  <br/>menjador 2 cops setmana complert = {{ D31() }} €-->
<!--  <br/>menjador 2 cops setmana lactants = {{ D32() }} €-->

<!--  <br/>menjador 1 cops setmana complert = {{ D34() }} €-->
<!--  <br/>menjador 1 cops setmana lactants = {{ D35() }} €-->

<!--  <br/>esporadic menjador complert = {{ D38() }} €-->
<!--  <br/>esporadic menjador lactants = {{ D39() }} €-->
<!--  <br/>esporadic berenar = {{ D40() }} €-->
<!--  <br/>esporadic 30 mins = {{ D41() }} €-->
